// Wait for the DOM to be ready
jQuery(document).ready(function ($) {
    // Initialize form validation on the registration form.
    // It has the name attribute "registration"
    $("form[name='apContactForm']").validate({
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            ap_reg_full_name: "required",
            ap_reg_email: {
                required: true,
                email: true
            },
            ap_reg_object: "required",
            ap_reg_message: "required",
        },
        // Specify validation error messages
        messages: {
            ap_reg_full_name: "Merci de renseigner votre nom et prénom.",
            ap_reg_email: "Merci de renseigner votre email.",
            ap_reg_object: "Merci de saisir un objet.",
            ap_reg_message: "Merci de saisir un message.",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function(form) {
            form.submit();
        }
    });
});